// extracted by mini-css-extract-plugin
export default {"mainWrapper":"mainWrapper_UyTV"};